import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysPlanNewRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const availableGoals = await this.reimaginedData.fetchAvailableGoals();

    return {
      availableGoals,
    };
  }
}
